import { debounce } from "./helpers";
import smoothscroll from 'smoothscroll-polyfill';

export default class BackToTop {
    constructor() {
        const button = this.backToTopButton ? this.backToTopButton : false;

        if(button) {
            smoothscroll.polyfill();

            this.listenForClick(button);
            this.toggleClass(button);
        }
    }

    get backToTopButton() {
        return document.querySelector('.js-backToTop');
    }

    listenForClick(button) {
        button.addEventListener('click', e => {
            e.preventDefault();
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        })
    }

    toggleClass(button) {
        document.addEventListener('scroll', debounce(e => {
            if(window.scrollY > 200) {
                button.classList.add('back-to-top--visible');
            } else {
                button.classList.remove('back-to-top--visible');
            }
        }, 100))
    }
}